export const fixedTelephoneShow = (save: string | number): string => {
  if (save) {
    const ary = save.toString().split('|') || ['', '', '']
    let res = ''
    const main = ary[1] || ''
    res = main
    const area = ary[0] || ''
    res = (area ? `(${area})` : '') + res
    const exts = ary[2] || ''
    res = res + (exts ? `转${exts}` : '')
    return res
  } else {
    return ''
  }
}
